const questions = [
  {
    id: 1,
    question: "She ___ to school yesterday.",
    options: ["go", "went", "gone"],
    answer: "went",
    concept: "past_simple_irregular",
    skill: "irregular_verb",
    explanation: "Some verbs are irregular in the Past Simple, like go → went."
  },
  {
    id: 2,
    question: "Which sentence is correct?",
    options: [
      "They watch a movie last night.",
      "They watched a movie last night.",
      "They are watching a movie last night."
    ],
    answer: "They watched a movie last night.",
    concept: "past_simple_regular",
    skill: "regular_verb_ed",
    explanation: "Regular verbs add -ed in the Past Simple."
  },
  {
    id: 3,
    question: "___ you study English last year?",
    options: ["Do", "Did", "Does"],
    answer: "Did",
    concept: "past_simple_questions",
    skill: "auxiliary_did",
    explanation: "Use 'Did' to form questions in the Past Simple."
  },
  {
    id: 4,
    question: "Choose the correct negative sentence.",
    options: [
      "He doesn't like the food yesterday.",
      "He didn't like the food.",
      "He isn't like the food."
    ],
    answer: "He didn't like the food.",
    concept: "past_simple_negative",
    skill: "did_not_base_form",
    explanation: "Negative sentences use did not + base verb."
  },
  {
    id: 5,
    question: "Which sentence talks about a finished action?",
    options: [
      "We play football every day.",
      "We are playing football now.",
      "We played football yesterday."
    ],
    answer: "We played football yesterday.",
    concept: "past_simple_usage",
    skill: "tense_usage",
    explanation: "The Past Simple is used for finished actions in the past."
  }
];

export default questions;


